import { render } from "./BackButton.vue?vue&type=template&id=22bc6544&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=22bc6544&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bc6544"]])

export default __exports__